import React from 'react';

/*
 * r16m: the router <Link> for the Follow-back card's two links (the batch chip, "open the Follow-back page"). The Slot Stats cards had
 * no router link before r16m, so the Slot Stats suites render them without a router - and CRA's Jest 27 cannot resolve react-router v7
 * at all (its "main" points at a missing file; the page suites mock it virtually). Required lazily: the built app always has the real
 * Link (an in-app navigation); a test environment without the module gets a plain link to the same path.
 */
let RRLink = null;
try {
  // eslint-disable-next-line global-require
  RRLink = require('react-router-dom').Link || null;
} catch (e) {
  RRLink = null;
}

export default function RouterLink({ to, children, ...rest }) {
  if (RRLink) return <RRLink to={to} {...rest}>{children}</RRLink>;
  return <a href={String(to)} {...rest}>{children}</a>;
}
